import { render, staticRenderFns } from "./PhotoUploadBeforeAfterTable.vue?vue&type=template&id=0f108543&scoped=true"
import script from "./PhotoUploadBeforeAfterTable.vue?vue&type=script&lang=js"
export * from "./PhotoUploadBeforeAfterTable.vue?vue&type=script&lang=js"
import style0 from "./PhotoUploadBeforeAfterTable.vue?vue&type=style&index=0&id=0f108543&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f108543",
  null
  
)

export default component.exports